import React, { PureComponent } from 'react'


export default (Component) =>
  class WrappedComponent extends PureComponent {

    state = {
      listeners: [],
    }

    componentWillUnmount() {
      this.removeListeners()
    }

    saveListener = ({ object, listener, callback }) => {
      const { listeners } = this.state

      this.setState({
        listeners: listeners.concat({ object, listener, callback }),
      })
    }

    setListener = (object, listener, callback) => {
      this.saveListener({ object, listener, callback })

      object.addEventListener(listener, callback)
    }

    removeListener = () => {
      this.removeListeners()
      this.setState({
        listeners: [],
      })
    }

    removeListeners = () => {
      const { listeners } = this.state

      listeners.forEach(({ object, listener, callback }) => {
        object.removeEventListener(listener, callback)
      })
    }

    checkIsChild = (node, targetNode) => {
      if (!node) {
        return false
      }

      if (node === targetNode) {
        return true
      }

      return this.checkIsChild(node.parentNode, targetNode)
    }

    render() {

      return (
        <Component
          {...this.props}
          setListener={this.setListener}
          checkIsChild={this.checkIsChild}
          removeListener={this.removeListener}
        />
      )
    }
  }
